import React from 'react';
import Lottie from 'react-lottie';
import './Weighing_Lottie.css';
import * as animationData from './Weighing_Lottie.json';

function Weighing_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Weighing_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Weighing_Lottie;